import moment from 'moment';
import agent from "../../services/agent";
import { LOGIN_ERROR, LOGIN_FORM, LOGIN_USER_SUCCESS, LOGOUT_USER, SET_CURRENT_PROFILE, SET_ERROR_MESSAGE, SET_IS_LOADING, SET_LOADING } from "./constants"

export const LoginForm = (data) => ({
  type: LOGIN_FORM,
  payload: { data }
})

export const SetLoading = (loading) => ({
  type: SET_LOADING,
  payload: { loading }
})

export const setErrorMessage = (errorMessage) => ({
  type: SET_ERROR_MESSAGE,
  payload: { errorMessage }
})


export const setCurrentProfile = (currentProfile) => ({
  type: SET_CURRENT_PROFILE,
  payload: currentProfile,
});

export const loginUserSuccess = (
  email: string,
  token: string,
  expiresInSec: number
) => ({
  type: LOGIN_USER_SUCCESS,
  payload: { email, token, expiresInSec },
})

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const setTokenDetails = (authData: any) => {
  const { accessToken, expiresInSec, tokenType } = authData;
  const expires = moment().unix() + expiresInSec;
  localStorage.setItem("token", accessToken);
  localStorage.setItem("expires_in", expires);
  localStorage.setItem("token_type", tokenType);
};
export const loginUserError = (errorMessage: string) => ({
  type: LOGIN_ERROR,
  payload: { errorMessage },
});

export const setIsLoading = (isloading) => ({
  type: SET_IS_LOADING,
  payload: { isloading },
});


export const userLogin = () => (dispatch: Function, getState: Function) => {
  const currentState = getState();
  const { Login } = currentState;
  const { data } = Login;


  dispatch(loginUserError(''));
  dispatch(setIsLoading(true))
  agent.Auth.login(data.email, data.password)
    .then((authData) => {
      setTokenDetails(authData);
      const { accessToken, expiresInSec } = authData;
      agent.Auth.getCurrentUser(accessToken)
        .then((currentUser) => {
          dispatch(setCurrentProfile(currentUser));
          dispatch(
            loginUserSuccess(currentUser.email, accessToken, expiresInSec)
          );
          dispatch(setIsLoading(false))
        })
    })
    .catch((err) => {
      if (err && err.response) {
        const error  = err.response.body.title;
        dispatch(loginUserError(error));
        dispatch(setIsLoading(false))
      } else {
        console.log("User login server error", err);
          dispatch(setIsLoading(false))
        dispatch(loginUserError('something went wrong. Please try again later'));
      }
    });
}